import { BaseFieldProps } from "./BaseFieldProps";
import React from "react";
import { OIDCUrlField } from "./OIDCUrlField";

export const WellKnownMetadataURLField = ({ disabled = false, onChange, value = "" }: BaseFieldProps) => {
    return (
        <OIDCUrlField
            id="well-known"
            label="Well Known Metadata URL"
            description="Publicly accessible endpoint that serves its OpenID configuration document"
            examples={["(i.e. https://idp.example.com/.well-known/openid-configuration)"]}
            disabled={disabled}
            onChange={onChange}
            value={value}
        />
    );
};

WellKnownMetadataURLField.displayName = "WellKnownMetadataURLField";
